export const SCAN_PERIOD_24_HOURS = 24;
export const SCAN_PERIOD_12_HOURS = 12;

// Backend v1 всегда планирует запуски по UTC.
export const SCAN_PERIOD_OPTIONS: Array<{ value: number; label: string }> = [
  {
    value: SCAN_PERIOD_24_HOURS,
    label: 'Каждые 24 часа — запуск в 00:00 (UTC)',
  },
  {
    value: SCAN_PERIOD_12_HOURS,
    label: 'Каждые 12 часов — запуск в 00:00 и 12:00 (UTC)',
  },
];
